/* eslint-disable */
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import { assetImages } from "constants";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TaskManagementPopup from "components/Common/Popup/TaskManagementPopup/TaskManagementPopup";
import MyTaskFilterPopup from "components/Common/Popup/MyTaskFilterPopup";
import MyTaskListHeader from "./Header/MyTaskListHeader";
import {
  getDateFormatInSpanish,
  replaceListByIds,
} from "helper/Common/CommonHelper";
import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
import AssignBulkTaskModal from "components/Common/Modal/AssignBulkTaskModal";
import SuccessBulkTaskModal from "components/Common/Modal/SuccessBulkTaskModal";
import DeleteTaskWarningModal from "components/Common/Modal/DeleteTaskWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddAlertModal from "components/Common/Modal/AddAlertModal";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
import UpdateTaskSchedulePopup from "components/Common/Popup/UpdateTaskSchedulePopup";
import { createTaskChatHandler } from "helper/TaskHelper/TaskHelper";
import AddMultipleTaskModal from "components/Common/Modal/AddMultipleTaskModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import TaskAdvanceFilterPopup from "components/Common/Popup/TaskAdvanceFilterPopup";
import UpdateBulkTaskPopup from "components/Common/Popup/UpdateBulkTaskPopup";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const MyTaskListBody = () => {
  const params = useParams();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t, i18n } = useTranslation(); //for translation

  const [isLoading, setIsLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [delayedTaskCount, setdelayedTaskCount] = useState(0);
  const [followingTaskCount, setfollowingTaskCount] = useState(0);
  const [inProgressTaskCount, setinProgressTaskCount] = useState(0);
  const [testingTaskCount, settestingTaskCount] = useState(0);
  const [pendingTaskCount, setpendingTaskCount] = useState(0);
  const [completedTaskCount, setcompletedTaskCount] = useState(0);
  const [totalTaskHours, settotalTaskHours] = useState(0);
  const [totalTaskLogHours, settotalTaskLogHours] = useState(0);
  const [taskTotalPendingHours, setTaskTotalPendingHours] = useState(0);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [afterSavedTaskData, setAfterSavedTaskData] = useState(null); //store new saved task to prevent refresh

  const [selectedTaskModerator, setselectedTaskModerator] = useState(null);

  const [showSkeleton, setShowSkeleton] = useState(false);

  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // null = popup hasn't decided yet (skip API call)
  // [] = no filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [bulkSavedTaskList, setBulkSavedTaskList] = useState([]);

  const [updateScheduleTaskUserList, setUpdateScheduleTaskUserList] = useState(
    [],
  );

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  // paginatin ends -----------------------------------

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // download to excel
  const [excelData, setExcelData] = useState([]);

  //get all tasks
  // ✅ CHANGED: withSkeleton param controls skeleton visibility
  // true  = initial load or reset → show skeleton
  // false = search typing        → no skeleton, table stays visible
  const getAllTask = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TASKS + `?token=${token}`;

      if (params.userid) {
        requestUrl = requestUrl + `&filterusers=${params.userid}`;
      }

      // append search term if provided
      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log(`getAllTask requestUrl--->`, requestUrl);

      const response = await getData(requestUrl);

      console.log("response in task list------->", response);

      if (response.status) {
        setMessageType("success");
        setTaskList(response.data);

        const delayedFilterTask = response.data.filter((task) => {
          return task.tasknumberofdaysleft < 0;
        });

        setdelayedTaskCount(delayedFilterTask.length);

        //get follwing tasks
        const followingTasks = response.data.filter(
          (task) => task.followers && task.followers.includes(userInfo._id),
        );

        setfollowingTaskCount(followingTasks.length);

        //get in progress tasks
        const inProgressTasks = response.data.filter(
          (task) => task.completedpercent === "1",
        );

        setinProgressTaskCount(inProgressTasks.length);

        //get testing tasks
        const testingTasks = response.data.filter(
          (task) => task.completedpercent === "2",
        );

        settestingTaskCount(testingTasks.length);

        //get pending tasks
        const pendingTasks = response.data.filter(
          (task) => task.completedpercent === "0",
        );

        setpendingTaskCount(pendingTasks.length);

        //get completed tasks
        const completedTasks = response.data.filter(
          (task) => task.completedpercent === "3",
        );

        setcompletedTaskCount(completedTasks.length);

        //get total planned hours
        const sumOfPlannedHours = response.data.reduce((acc, curr) => {
          return acc + curr.hours;
        }, 0);

        settotalTaskHours(sumOfPlannedHours);

        //get total dedicated hours
        const sumOfDedicatedHours = response.data.reduce((acc, curr) => {
          return acc + curr.loggedhours;
        }, 0);

        settotalTaskLogHours(sumOfDedicatedHours);

        const sumOfPendingHours = response.data.reduce((acc, curr) => {
          return acc + curr.taskpendinghours;
        }, 0);

        setTaskTotalPendingHours(sumOfPendingHours.toFixed(2));
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowSkeleton(false); // ✅ skeleton close
      setShowAlert(true);
    }
  };

  // get tasks by filter
  const getTasksByFilter = async (searchTerm = "", withSkeleton = false) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_TASKS + `?token=${token}`;

      // append search term if provided
      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setTaskList(response.data);

        const delayedFilterTask = response.data.filter((task) => {
          return task.tasknumberofdaysleft < 0;
        });

        setdelayedTaskCount(delayedFilterTask.length);

        //get follwing tasks
        const followingTasks = response.data.filter(
          (task) => task.followers && task.followers.includes(userInfo._id),
        );

        setfollowingTaskCount(followingTasks.length);

        //get in progress tasks
        const inProgressTasks = response.data.filter(
          (task) => task.completedpercent === "1",
        );

        setinProgressTaskCount(inProgressTasks.length);

        //get testing tasks
        const testingTasks = response.data.filter(
          (task) => task.completedpercent === "2",
        );

        settestingTaskCount(testingTasks.length);

        //get pending tasks
        const pendingTasks = response.data.filter(
          (task) => task.completedpercent === "0",
        );

        setpendingTaskCount(pendingTasks.length);

        //get completed tasks
        const completedTasks = response.data.filter(
          (task) => task.completedpercent === "3",
        );

        setcompletedTaskCount(completedTasks.length);

        //get total planned hours
        const sumOfPlannedHours = response.data.reduce((acc, curr) => {
          return acc + curr.hours;
        }, 0);

        settotalTaskHours(sumOfPlannedHours);

        //get total dedicated hours
        const sumOfDedicatedHours = response.data.reduce((acc, curr) => {
          return acc + curr.loggedhours;
        }, 0);

        settotalTaskLogHours(sumOfDedicatedHours);

        const sumOfPendingHours = response.data.reduce((acc, curr) => {
          return acc + curr.taskpendinghours;
        }, 0);

        setTaskTotalPendingHours(sumOfPendingHours.toFixed(2));
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowSkeleton(false); // close skeleton
      setShowAlert(true);
    }
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedTaskList = [...taskList];

    const rowIndex = updatedTaskList.findIndex(
      (task) => task._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedTaskList[rowIndex].rank = value;
      setTaskList(updatedTaskList);
    }
  };

  //function for change complete percent
  const completePercentInputChangeHandler = (row, value) => {
    const updatedTaskList = [...taskList];

    const rowIndex = updatedTaskList.findIndex(
      (task) => task._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedTaskList[rowIndex].taskpercent = value;
      setTaskList(updatedTaskList);
    }
  };

  //function for change planed hours
  const plannedHoursInputChangeHandler = (row, value) => {
    const updatedTaskList = [...taskList];

    const rowIndex = updatedTaskList.findIndex(
      (task) => task._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedTaskList[rowIndex].hours = value;
      setTaskList(updatedTaskList);
    }
  };

  //function for change start date
  const startDateInputChangeHandler = (row, value) => {
    const updatedTaskList = [...taskList];

    const rowIndex = updatedTaskList.findIndex(
      (task) => task._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedTaskList[rowIndex].startdate = value;

      console.log(updatedTaskList);

      setTaskList(updatedTaskList);
    }
  };

  //function for change end date
  const endDateInputChangeHandler = (row, value) => {
    const updatedTaskList = [...taskList];

    const rowIndex = updatedTaskList.findIndex(
      (task) => task._id === row.original._id,
    );

    if (rowIndex !== -1) {
      updatedTaskList[rowIndex].enddate = value;
      setTaskList(updatedTaskList);
    }
  };

  //function for update input fields
  const updateTaskInputHandler = async () => {
    if (selectedTaskIds.length === 0) {
      setMessageType("error");
      setAlertMessage("Please select at least one task");
      setShowAlert(true);
      return;
    }

    try {
      // Step 1: Filter only selected tasks from taskList
      const selectedTasks = taskList.filter((task) =>
        selectedTaskIds.includes(task._id),
      );

      // Step 2: Prepare all requests
      const requests = selectedTasks.map(async (task) => {
        const taskData = {
          rank: task.rank,
          taskpercent: task.taskpercent,
          startdate: task.startdate,
          enddate: task.enddate,
          hours: task.hours,
        };

        const requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_PROJECT_TASK +
          `/${task._id}?token=${token}`;

        await putData(requestUrl, taskData);
      });

      // Step 3: Run all requests in parallel
      await Promise.all(requests);

      // Step 4: Refresh after success
      if (requests.length > 0) {
        setAlertMessage("Task updated successfully");
        setMessageType("success");
        setTimeout(() => {
          setSelectedTaskIds([]);
          setRowSelection({});
        }, 1500);
      } else {
        setAlertMessage("No task updated");
        setMessageType("error");
      }
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setShowAlert(true);
    }
  };

  const updateBulkTaskHandler = () => {
    if (selectedTaskIds.length === 0) {
      setAlertMessage("Please select atleast one task");
      setMessageType("error");
      setShowAlert(true);

      return;
    }

    //show updatebulktaskpopup
    const updateBulkTaskPopup = document.querySelector("#updateBulkTask");
    const offcanvas = new bootstrap.Offcanvas(updateBulkTaskPopup);
    offcanvas.show();
  };

  //delete multiple tasks
  const deActivateBulkTaskHandler = async () => {
    if (selectedTaskIds.length > 0) {
      let responseArr = [];

      //run loop checkbox wise
      for (let updatedTaskId of selectedTaskIds) {
        try {
          let requestUrl =
            url.API_BASE_URL +
            url.API_DEACTIVATE_PROJECT_TASK +
            `/${updatedTaskId}` +
            `?token=${token}`;

          const response = await putData(requestUrl);

          if (response.status) {
            setMessageType("success");
            responseArr.push(response.status);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setAlertMessage(error.message);
          setMessageType("error");
        }

        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          setTaskList((prevList) =>
            prevList.filter((item) => !selectedTaskIds.includes(item._id)),
          );
        }, 1500);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one task");
      setShowAlert(true);
    }
  };

  //update schedule to state
  const updateBulkTaskScheduleStateHandler = () => {
    if (selectedTaskIds.length > 0) {
      const selectedTasksList = taskList.filter((item) =>
        selectedTaskIds.includes(item._id),
      );

      let filteredTaskList = [];

      if (
        userInfo.role.slug === "ADMIN" ||
        userInfo.role.slug === "SUPER_ADMIN"
      ) {
        filteredTaskList = selectedTasksList;
      } else {
        filteredTaskList = selectedTasksList.filter(
          (item) => item.moderator.toString() === userInfo._id.toString(),
        );
      }

      const transformedTasksArray = [];

      // Helper function to initialize weekly work days
      const initializeWeekly = () => ({
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
      });

      // Group tasks by assigned user
      const userTasksMap = filteredTaskList.reduce((acc, task) => {
        const userId = task.assigneduser || null;
        if (!acc[userId]) {
          acc[userId] = {
            assigneduser: task.assigneduser || null,
            assignedusername: task.assignedusername || "",
            assigneduserimage: task.assigneduserimage || "",
            tasks: [],
            workhours: 0,
            ...initializeWeekly(),
          };
        }
        acc[userId].tasks.push(task);
        return acc;
      }, {});

      // Transform the map into the desired array format
      // for (const userId in userTasksMap) {
      //   transformedTasksArray.push(userTasksMap[userId]);
      // }
      for (const userId in userTasksMap) {
        // Sort tasks by priority: 1, 2, then 3
        userTasksMap[userId].tasks.sort((a, b) => {
          return Number(a.rank) - Number(b.rank);
        });

        transformedTasksArray.push(userTasksMap[userId]);
      }

      setUpdateScheduleTaskUserList(transformedTasksArray);

      if (filteredTaskList.length > 0) {
        let offCanvasPopup = document.querySelector("#UpdateTaskSchedule");
        let offCanvas = new bootstrap.Offcanvas(offCanvasPopup);
        offCanvas.show();
      } else {
        setMessageType("error");
        setAlertMessage("You are not authorized to perform this action");
        setShowAlert(true);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one task");
      setShowAlert(true);
    }
  };

  //function for remove tag from task
  const removeTagFromTask = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_TAG_TASK;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedTaskId(null);
      }, 1000);
    }
  };

  const closeBulkTaskModalHandler = (data = []) => {
    if (data.length > 0) {
      setTaskList((prevTasks) => [...data, ...prevTasks]);
    }
  };

  //* Function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedTaskIds([]);
    setJsonFilterQuery(null); // null = triggers fetch all via jsonFilterQuery effect
    setIsFilterReset(true);
    setReloadData(true);
    setGlobalSearch(""); // reset search input
    setDebouncedSearch(""); // reset debounced search
    setLastPagination({ pageIndex: 0, pageSize: 10 });
    setPagination({ pageIndex: 0, pageSize: 10 });
  };

  // ─────────────────────────────────────────────
  // ─── Close modal handler
  // ─────────────────────────────────────────────
  const afterCloseModalHandler = (isGetAllList) => {
    if (isGetAllList) {
      getAllTask("", true); // ✅
    } else {
      setRowSelection({});
      setSelectedTaskIds([]);
    }
  };

  // ─────────────────────────────────────────────
  // ─── Bulk task update
  // ─────────────────────────────────────────────
  const afterBulkTaskUpdate = (data = []) => {
    setSelectedTaskIds([]);
    setRowSelection({});

    setTaskList((prevTasks) => {
      let updatedTasks = [...prevTasks];

      data.forEach((afterSavedTaskData) => {
        const existingIndex = updatedTasks.findIndex(
          (task) => task._id.toString() === afterSavedTaskData._id.toString(),
        );

        if (existingIndex !== -1) {
          // Replace existing task
          updatedTasks[existingIndex] = afterSavedTaskData;
        } else {
          // Add new task at start
          updatedTasks.unshift(afterSavedTaskData);
        }
      });

      return updatedTasks;
    });
  };

  // ─────────────────────────────────────────────
  // ─── Modal action close
  // ─────────────────────────────────────────────
  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setTaskList((prevTasks) => replaceListByIds(prevTasks, data));
    }, 1000);
  };

  // State to manage the filter values for each column
  const [columnFilterValues, setColumnFilterValues] = useState({});
  const [showGlobalFilters, setShowGlobalFilters] = useState(false);

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#addTask_view"
          aria-controls="addTask_view"
          onClick={() => {
            setSelectedTaskId(row.original._id);
            setselectedTaskModerator(row.original.moderator);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "customid",
      header: t("ID"),
      size: 100,
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tags.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tags &&
                  row.original.tags.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedTagId(tag._id);
                            setSelectedTaskId(row.original._id);
                            removeTagFromTask([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedTaskId &&
                          selectedTaskId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedTaskIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "title",
      header: t("Title"),
      size: 300,
      Cell: ({ row }) => (
        <div className="title border-bottom-0">
          <div className="d-flex align-items-center gap-4">
            {/* <p className="fs-md fw-semibold"></p> */}
            <Link
              to={`/admin/task/details/${row.original._id}`}
              className="d-flex align-items-center gap-1 fs-md"
            >
              {row.original.title}
            </Link>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "rank",
      header: t("Rank"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {row.original.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ? (
            <input
              type="number"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "100px" }}
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="ps-3">{row.original.rank}</p>
          )}
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "taskstatus",
      header: t("Task Status"),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "taskpercent",
      header: t("Complete %"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          row.original.moderator.toString() === userInfo._id.toString() ? (
            <input
              type="number"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "100px" }}
              value={row.original.taskpercent}
              onChange={(e) =>
                completePercentInputChangeHandler(row, e.target.value)
              }
            />
          ) : (
            <p className="ps-3">{row.original.taskpercent}</p>
          )}
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "projectname",
      header: t("Project"),
      size: 250,
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "taskpriority",
      header: t("Priority"),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "hours",
      header: t("Planned Hours"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {row.original.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          (row.original.assigneduser &&
            row.original.assigneduser.toString() ===
              userInfo._id.toString()) ? (
            <input
              type="number"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "100px" }}
              value={row.original.hours}
              onChange={(e) =>
                plannedHoursInputChangeHandler(row, e.target.value)
              }
            />
          ) : (
            <p className="ps-3">{row.original.hours}</p>
          )}
        </div>
      ),
      // Cell: ({ row }) => (
      //   <input
      //     type="number"
      //     className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
      //     style={{ width: "100px" }}
      //     value={row.original.hours}
      //     onChange={(e) => plannedHoursInputChangeHandler(row, e.target.value)}
      //   />
      // ),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "loggedhours",
      header: t("Dedicated Hours"),
    },
    {
      accessorKey: "balancehours",
      header: t("Balance Hours"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          <p
            className={`ps-3 ${
              row.original.balancehours < 0 ? "text-danger" : ""
            }`}
          >
            {row.original.balancehours}
          </p>
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "taskpendinghours",
      header: t("Pending Hours"),
      // Filter: globalFilterTextHandler,
      size: 200,
    },
    {
      accessorKey: "taskcreateddate",
      header: t("Task Created Date"),
      size: 200,
    },
    {
      accessorKey: "startdate",
      header: t("Start Date"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          row.original.moderator.toString() === userInfo._id.toString() ||
          (row.original.assigneduser &&
            row.original.assigneduser.toString() ===
              userInfo._id.toString()) ? (
            <input
              type="date"
              className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "140px" }}
              value={row.original.startdate}
              onChange={(e) => startDateInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="ps-2">{row.original.taskstartdate}</p>
          )}
        </div>
      ),
      // Cell: ({ row }) => (
      //   <input
      //     type="date"
      //     className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
      //     style={{ width: "140px" }}
      //     value={row.original.startdate}
      //     onChange={(e) => startDateInputChangeHandler(row, e.target.value)}
      //   />
      // ),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "enddate",
      header: t("End Date"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          row.original.moderator.toString() === userInfo._id.toString() ||
          (row.original.assigneduser &&
            row.original.assigneduser.toString() ===
              userInfo._id.toString()) ? (
            <input
              type="date"
              className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "140px" }}
              value={row.original.enddate}
              onChange={(e) => endDateInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="ps-2">{row.original.taskenddate}</p>
          )}
        </div>
      ),
    },
    {
      accessorKey: "tasknumberofdaysleft",
      header: t("Days Left"),
      Cell: ({ row }) => (
        <Box className="title border-bottom-0" sx={{ width: "200px" }}>
          <div className="d-flex align-items-center gap-4">
            <p
              className={
                row.original.tasknumberofdaysleft <= 3 ? "text-primary" : ""
              }
            >
              {" "}
              {row.original.tasknumberofdaysleft}
            </p>
          </div>
        </Box>
      ),
      // Filter: globalFilterTextHandler,
    },
    //moderator
    {
      accessorKey: "moderatorname",
      header: t("Assigned By"),
      size: 300,
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          <img
            className="rounded-circle"
            height={35}
            width={35}
            src={
              row.original.moderatorimage == ""
                ? assetImages.defaultUser
                : url.SERVER_URL + row.original.moderatorimage
            }
            alt="Babcock"
          />
          <p>
            <span className="d-block">{row.original.moderatorname}</span>
            <span className="d-block">{row.original.moderatoremail}</span>
          </p>
          <button
            onClick={() => {
              createTaskChatHandler(row.original._id);
            }}
            className={
              row.original.moderator.toString() === userInfo._id.toString()
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    //assigned user
    {
      accessorKey: "assignedusername",
      header: t("Assigned To"),
      size: 300,
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          {row.original.assignedusername === "" ? null : (
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assigneduserimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assigneduserimage
              }
              alt="Babcock"
            />
          )}
          <p>
            <span className="d-block">{row.original.assignedusername}</span>
            <span className="d-block">{row.original.assigneduseremail}</span>
          </p>
          <button
            onClick={() => {
              createTaskChatHandler(row.original._id);
            }}
            className={
              !row.original.assigneduser ||
              row.original.assigneduser === userInfo._id
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    //follower
    {
      accessorKey: "followersnames",
      header: t("Followers"),
      size: 250,
      Cell: ({ row }) =>
        row.original.followerslist.map((follower, index) => (
          <div className="owner border-bottom-0 d-flex gap-1 mb-1" key={index}>
            <img
              className="rounded-circle"
              height={15}
              width={15}
              src={
                follower.image == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + follower.image
              }
              alt="Babcock"
            />

            <p>
              <span className="d-block">{follower.fullname}</span>
            </p>
            <button
              onClick={() => {
                createTaskChatHandler(row.original._id);
              }}
              className={
                follower._id === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        )),
    },
    {
      accessorKey: "projectsectionname",
      header: t("Section"),
      size: 200,
      // Filter: globalFilterTextHandler,
    },
    //log updated by
    {
      accessorKey: "tasklogupdatedperson",
      header: t("Log Updated By"),
      size: 300,
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          {row.original.tasklogupdatedpersonimage == "" ? null : (
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={url.SERVER_URL + row.original.tasklogupdatedpersonimage}
              alt="Babcock"
            />
          )}
          <p>
            <span className="d-block">
              {row.original.tasklogupdatedpersonname}
            </span>
            <span className="d-block">
              {row.original.tasklogupdatedpersonemail}
            </span>
          </p>
          <button
            onClick={() => {
              createTaskChatHandler(row.original._id);
            }}
            className={
              !row.original.logupdatedby ||
              row.original.logupdatedby === userInfo._id
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
      // Filter: globalFilterTextHandler,
    },
    //log updated on
    {
      accessorKey: "tasklogupdatedon",
      header: t("Log updated on"),
      // Filter: globalFilterTextHandler,
    },
    {
      accessorKey: "leadtitle",
      header: t("Lead"),
      // Filter: globalFilterTextHandler,
      size: 200,
    },
    {
      accessorKey: "contactname",
      header: t("Contact"),
      // Filter: globalFilterTextHandler,
      size: 200,
    },
    {
      accessorKey: "parenttask",
      header: t("Parent Task"),
    },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    // [taskList, columnFilterValues]
    [taskList, selectedTagId, i18n.language],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  /* Updates the column visibility state based on the new column state.*/
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  // ─────────────────────────────────────────────
  // ─── Get all task on mount
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (params.userid) {
      getAllTask("", true);
    }
  }, [params.userid]);

  // ─────────────────────────────────────────────
  // ─── Reload effect — triggered by reset or refresh button.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (reloadData) {
      getAllTask("", true); // show skeleton on reload
      setReloadData(false);
    }
  }, [reloadData]);

  // ─────────────────────────────────────────────
  // ─── Filter effect — triggered by filter popup.
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery.length > 0) {
      getTasksByFilter(debouncedSearch, true); // filter apply — show skeleton
    } else {
      getAllTask(debouncedSearch, true); // no filter — show skeleton
    }
  }, [jsonFilterQuery]);

  // ─────────────────────────────────────────────
  // ─── Debounce global search — 600ms
  // ─────────────────────────────────────────────
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  // ─────────────────────────────────────────────
  // Search effect — no skeleton, table stays visible while searching
  // ─────────────────────────────────────────────
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load to finish

    if (jsonFilterQuery?.length > 0) {
      getTasksByFilter(debouncedSearch, false); // no skeleton while typing
    } else {
      getAllTask(debouncedSearch, false); // no skeleton while typing
    }
  }, [debouncedSearch]);

  // ─────────────────────────────────────────────
  // ─── Row selection effect
  // ─────────────────────────────────────────────
  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedTaskIds(selectedIdsArray);
    } else {
      setSelectedTaskIds([]);
    }
  }, [rowSelection]);

  // ─────────────────────────────────────────────
  // ─── Save last pagination
  // ─────────────────────────────────────────────
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  //refresh icon function
  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  //download as excel
  const downloadAsExcel = () => {
    if (taskList.length > 0) {
      const createRowData = (apiData) => [
        apiData.customid,
        apiData.title,
        apiData.rank,
        apiData.taskstatus,
        apiData.completedpercent,
        apiData.projectname,
        apiData.taskpriority,
        apiData.hours,
        apiData.loggedhours,
        apiData.balancehours,
        apiData.startdate,
        apiData.enddate,
        apiData.tasknumberofdaysleft,
        apiData.moderatorname,
        apiData.assignedusername,
        apiData.followersnames,
        apiData.projectsectionname,
        apiData.tasklogupdatedperson,
        apiData.tasklogupdatedon,
        apiData.leadtitle,
        apiData.contactname,
        apiData.tagstring,
      ];

      const filteredList =
        selectedTaskIds.length > 0
          ? taskList.filter((item) => selectedTaskIds.includes(item._id))
          : taskList;

      filteredList.map((apiData) => {
        const rowData = createRowData(apiData);
        setExcelData((prevState) => [...prevState, rowData]);
      });
    }
  };

  const createExcel = () => {
    const fileName = "tasks";

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileExtension = ".xlsx";

    const Heading = [
      [
        "ID",
        "Title",
        "Rank",
        "Task Status",
        "Complete %",
        "Project",
        "Priority",
        "Planned Hours",
        "Dedicated Hours",
        "Balance Hours",
        "Start Date",
        "End Date",
        "Days Left",
        "Assigned By",
        "Assigned To",
        "Followers",
        "Section",
        "Log Updated By",
        "Log Updated On",
        "Lead",
        "Contact",
        "Label",
      ],
    ];

    const ws = XLSX.utils.json_to_sheet(excelData, {
      origin: "A2",
      skipHeader: true,
    });

    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" });

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const filedata = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(filedata, fileName + fileExtension);
  };

  useEffect(() => {
    // console.log("excelData", excelData);

    if (excelData.length > 0) {
      createExcel();
      setExcelData([]);
    }
  }, [excelData]);

  // download excel ends

  useEffect(() => {
    if (afterSavedTaskData) {
      // console.log("afterSavedTaskData---->", afterSavedTaskData);

      setTaskList((prevTasks) => {
        const existingIndex = taskList.findIndex(
          (task) => task._id.toString() === afterSavedTaskData._id.toString(),
        );

        // update existing task with updated data, if task exists in the list
        if (existingIndex !== -1) {
          const updatedTasks = [...prevTasks];
          updatedTasks[existingIndex] = afterSavedTaskData;
          return updatedTasks;
        } else {
          // if task does not exist, add new task at index 0
          return [afterSavedTaskData, ...prevTasks];
        }
      });

      setAfterSavedTaskData(null);
    }
  }, [afterSavedTaskData]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_TASK")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* -------- header area ---------- */}
            <MyTaskListHeader
              userInfo={userInfo}
              reloadList={refreshRecords}
              updateBulkTaskHandler={updateBulkTaskHandler}
              updateTaskInputHandler={updateTaskInputHandler}
              setselectedTaskModerator={setselectedTaskModerator}
              updateScheduleStateHandler={updateBulkTaskScheduleStateHandler}
              downloadAsExcel={downloadAsExcel}
              taskList={taskList}
              delayedTaskCount={delayedTaskCount}
              followingTaskCount={followingTaskCount}
              inProgressTaskCount={inProgressTaskCount}
              testingTaskCount={testingTaskCount}
              pendingTaskCount={pendingTaskCount}
              completedTaskCount={completedTaskCount}
              totalTaskHours={totalTaskHours}
              totalTaskLogHours={totalTaskLogHours}
              taskTotalPendingHours={taskTotalPendingHours}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedTaskIds={selectedTaskIds}
            />

            {showSkeleton || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={taskList}
                  enableGrouping
                  enableRowSelection
                  enableColumnOrdering={true}
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                    globalFilter: globalSearch || undefined, // ✅ ADD
                  }}
                  onPaginationChange={setPagination}
                  autoResetPageIndex={false}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")} // ✅ ADD — typing triggers search
                  defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ========= popups and modals area ======== */}

        {/* ---------- filter popup ---------- */}
        {/* <MyTaskFilterPopup
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          columnFilterValues={columnFilterValues}
          setColumnFilterValues={setColumnFilterValues}
          showGlobalFilters={showGlobalFilters}
          setShowGlobalFilters={setShowGlobalFilters}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          filterTaskDateRangeType={filterTaskDateRangeType}
          setFilterTaskDateRangeType={setFilterTaskDateRangeType}
          filterTaskFromDate={filterTaskFromDate}
          setfilterTaskFromDate={setfilterTaskFromDate}
          filterTaskToDate={filterTaskToDate}
          setfilterTaskToDate={setfilterTaskToDate}
          filterTaskCustomIds={filterTaskCustomIds}
          setfilterTaskCustomIds={setfilterTaskCustomIds}
          filterTaskTitle={filterTaskTitle}
          setfilterTaskTitle={setfilterTaskTitle}
          filterTaskProjects={filterTaskProjects}
          setfilterTaskProjects={setfilterTaskProjects}
          filterTaskAssignedByUsers={filterTaskAssignedByUsers}
          setfilterTaskAssignedToUsers={setfilterTaskAssignedToUsers}
          filterTaskAssignedToUsers={filterTaskAssignedToUsers}
          setfilterTaskAssignedByUsers={setfilterTaskAssignedByUsers}
          filterPreviousTasks={filterPreviousTasks}
          setfilterPreviousTasks={setfilterPreviousTasks}
          filterTaskStatus={filterTaskStatus}
          setfilterTaskStatus={setfilterTaskStatus}
          filterTaskPriorities={filterTaskPriorities}
          setfilterTaskPriorities={setfilterTaskPriorities}
          filterTaskLabels={filterTaskLabels}
          setfilterTaskLabels={setfilterTaskLabels}
          moduleName={params.userid ? `mytask${params.userid}` : "mytask"}
          setIsNoDefaultFilter={setIsNoDefaultFilter}
        /> */}

        {/* ---------- add project popup ------------ */}

        <TaskManagementPopup
          selectedModuleSlug=""
          moduleName={"mytask"}
          leadId={null}
          contactId={null}
          sectionId={null}
          projectId={null}
          selectedTaskId={selectedTaskId}
          selectedTaskModerator={selectedTaskModerator}
          isProjectModerator={false}
          projectValue={null}
          selectedSectionValue={null}
          leadValue={null}
          contactValue={null}
          onPopUpClose={() => {
            setSelectedTaskId(null);
            setselectedTaskModerator(null);
          }}
          getTaskList={(data) => {
            if (data) {
              setTimeout(() => {
                setAfterSavedTaskData(data);
              }, 1500);
            } else {
              setAfterSavedTaskData(null);
            }
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* -------- add label modal ---------- */}
        <AddLabelModal
          moduleName="task"
          selectedIds={selectedTaskIds}
          afterTagModalClose={afterModalActionClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedTaskIds([]);
            setRowSelection({});
          }}
          moduleSlug="MOD_TASK"
        />

        <AddFollowerModal
          moduleName="task"
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          selectedIds={selectedTaskIds}
          afterModalClose={afterModalActionClose}
          onModalClose={() => {
            setSelectedTaskIds([]);
            setRowSelection({});
          }}
        />

        <UpdateBulkTaskPopup
          taskIds={selectedTaskIds}
          afterPopupClose={afterBulkTaskUpdate}
          closePopupHandler={() => {
            setRowSelection({});
            setSelectedTaskIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        <AssignBulkTaskModal
          moduleName={"mytask"}
          userInfo={userInfo}
          afterCloseModalHandler={afterModalActionClose}
          selectedTasks={selectedTaskIds}
          setBulkSavedTaskList={setBulkSavedTaskList}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          onModalClose={() => {
            setSelectedTaskIds([]);
            setRowSelection({});
          }}
        />

        <SuccessBulkTaskModal
          bulkSavedTaskList={bulkSavedTaskList}
          afterModalClose={() => {
            setRowSelection({});
            setSelectedTaskIds([]);
          }}
        />

        <AddAlertModal
          selectedIds={selectedTaskIds}
          afterModalClose={() => {
            setSelectedTaskIds([]);
            setRowSelection({});
          }}
          moduleName={"task"}
        />

        <DeleteTaskWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedTaskIds([]);
          }}
          onDelete={deActivateBulkTaskHandler}
        />

        <UpdateTaskSchedulePopup
          updateScheduleTaskUserList={updateScheduleTaskUserList}
          setUpdateScheduleTaskUserList={setUpdateScheduleTaskUserList}
          reloadList={() => {
            setTimeout(() => {
              getAllTask("", true); // ✅ withSkeleton=true
            }, 2500);
          }}
          closePopupHandler={() => {
            setRowSelection({});
            setSelectedTaskIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* Add Multiple Tasks Modal */}
        <AddMultipleTaskModal handleClose={closeBulkTaskModalHandler} />

        <TaskAdvanceFilterPopup
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={refreshRecords}
          moduleSlug="mytask"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          columns={columns}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default MyTaskListBody;
